export default __webpack_public_path__ + "img/shape-hexagon-small.7e4e46a6.svg";